import { SitePricing } from "@/app/lib/generated/graphql-types";
import { notNull } from "@/app/lib/common/not-null";
import { SitePricingSchema } from "@/app/features/sites/pricing/types/schema";
import { SitePricingEditable } from "@/app/features/sites/pricing/types/types";

export function sitePricingEditableFrom(site: SitePricing): SitePricingEditable {
    return SitePricingSchema.parse({
        ...site,
        categories: site.categories.filter(notNull).map((category) => ({
            ...category,
            prices: category.prices?.filter(notNull) ?? null,
            links: category.links?.filter(notNull) ?? null,
        })),
        relatedInfos: site.relatedInfos.filter(notNull),
    });
}
